export default function TryOnExample({ image, tryOnText, setTryOnText }) {
  const tryOnExamples = [
    "Bell-sleeve blouse",
    "Ruffled crop top",
    "Pleated long skirt",
  ];

  const remix = () => {
    const randomTryOn =
      tryOnExamples[Math.floor(Math.random() * tryOnExamples.length)];
    setTryOnText(randomTryOn);
  };

  return (
    <div className="bg-gradient-to-b from-rose-50 to-amber-50 text-black p-4 rounded-xl space-y-4 border shadow-sm">
      <div className="flex gap-4">
        {/*  Image */}
        <div className="w-1/2 relative">
          {image ? (
            <>
              <img
                src={image}
                alt={tryOnText}
                className="rounded-lg w-full h-auto object-cover"
              />
            </>
          ) : (
            <div className="h-48 bg-gray-300 rounded-lg flex items-center justify-center">
              <span className="text-gray-700 text-center">
                No Image Selected
              </span>
            </div>
          )}
        </div>

        <div className="w-1/2">
          {image ? (
            <img
              src={image}
              alt={`${tryOnText} - right`}
              className="rounded-lg w-full h-auto object-cover"
            />
          ) : (
            <div className="h-48 bg-gray-300 rounded-lg flex items-center justify-center">
              <span className="text-gray-700 text-center">
                No Image Selected
              </span>
            </div>
          )}
        </div>
      </div>

      <p className="text-md font-semibold">Try On: {tryOnText}</p>

      <button
        onClick={remix}
        className="bg-pink-600 text-white px-3 py-1 rounded hover:bg-pink-700"
      >
        Remix
      </button>
    </div>
  );
}
